import React, { useEffect, useState } from 'react';
import Pagination from '../../components/Pagination';
import InnerLayout from '../../components/layouts/innerLayout';
import { useDispatch } from 'react-redux';
import { errorToast } from '../../components/toast';
import LoaderModal from '../../components/modals/loaderModal';
import { formatDate, formatString, statusColors } from '../../components/helper';
import { subscriptionsListAction } from '../../redux/actions/billingAction';
import moment from 'moment';

const SubscriptionList = () => {

    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationData, setPaginationData] = useState(null);
    const [subscriptions, setSubscriptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const itemsPerPage = 15;
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= paginationData?.totalPages) {
            setCurrentPage(newPage);
        }
    };


    useEffect(() => {
        fetchsubscriptions()
    }, [currentPage])

    const fetchsubscriptions = () => {
        setLoading(true)
        dispatch(subscriptionsListAction({ page: currentPage, page_size: itemsPerPage }, onSuccess, onError))
    }

    const onSuccess = (data) => {
        setSubscriptions(data.data.data.subscriptions);
        setPaginationData(data.data.data.pagination)
        setLoading(false)
    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
    }

    return (
        <InnerLayout module={"Subscription"} is_new={true} navigationPath={"/subscribe"}>
            <div className="w-full flex flex-col h-full p-4">
                <div className="bg-white shadow-lg rounded-lg overflow-auto flex-1">
                    <table className="min-w-full table-auto">
                        <thead className="bg-slate-300 sticky top-0">
                            <tr>
                                <th className="px-4 py-2">#</th>
                                <th className="px-4 py-2">Name</th>
                                <th className="px-4 py-2">Price</th>
                                <th className="px-4 py-2">Start Date</th>
                                <th className="px-4 py-2">End Date</th>
                                <th className="px-4 py-2">Status</th>
                                <th className="px-4 py-2">Purchased At</th>
                                <th className="px-4 py-2">Updated At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {subscriptions.length > 0 ? subscriptions.map((subscription) => (
                                <tr key={subscription.id} className="border-b hover:bg-primary-light cursor-pointer">
                                    <td className="py-2">{subscription.code}</td>
                                    <td className="py-2">{subscription?.purchased_plan?.name ?? "--"}</td>
                                    <td className="py-2">{subscription?.purchased_plan?.price ?? "--"}</td>
                                    <td className="py-2">{subscription?.start_date ? moment(subscription?.start_date).format('DD-MM-YYYY') : "--"}</td>
                                    <td className="py-2">{subscription?.end_date ? moment(subscription?.end_date).format('DD-MM-YYYY') : "--"}</td>
                                    <td className="py-2" style={{ color: statusColors.find(item => item.status.toLowerCase() === subscription?.status.toLowerCase()).color }} >
                                        {formatString(subscription.status === "pending" ? "Upcoming" : subscription.status) ?? "--"}
                                    </td>
                                    <td className="py-2">{formatDate(subscription.createdAt)}</td>
                                    <td className="py-2">{formatDate(subscription.updatedAt)}</td>
                                </tr>
                            ))
                                : <tr style={{ height: '30rem' }}>
                                    <td colSpan="9" className="py-4 text-center">
                                        No subscriptions found
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>


                {/* Pagination Footer */}
                <div className="bg-white p-4 mt-4 shadow-2xl">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={paginationData?.totalPages}
                        onPageChange={handlePageChange}
                    />
                </div>
                {loading &&
                    <LoaderModal />
                }
            </div>
        </InnerLayout>
    );
};

export default SubscriptionList;
